import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'
// import moment from 'moment'
import { format } from 'date-fns'

class FinalCounsellorAssessment extends Component {
  static propTypes = {
    handleFinalCounsellorAssessment: PropTypes.func.isRequired,
    handleFinalSelfAssessment: PropTypes.func.isRequired,
    // handleFinalSelfAssessmentNotes: PropTypes.func.isRequired,
    handleInterimCounsellorAssessmentNotes: PropTypes.func.isRequired,
    // handleInterimSelfAssessmentNotes: PropTypes.func.isRequired,
    partnerPlan: PropTypes.object.isRequired,
    selectedPlan: PropTypes.object.isRequired,
  }

  render() {
    const {
      partnerPlan,
      selectedPlan,
      // handleInterimSelfAssessmentNotes,
      handleInterimCounsellorAssessmentNotes,
      // handleFinalSelfAssessmentNotes,
      handleFinalSelfAssessment,
      handleFinalCounsellorAssessment,
    } = this.props

    const steps = [
      {
        key: 1,
        label: constants.PARTNERPLAN.STEPS.UPLOAD,
        desc: `${constants.PARTNERPLAN.STATUS.UPLOADED}: ${(partnerPlan.partnerPlan.planUploadedDate ?
          format(new Date(partnerPlan.partnerPlan.planUploadedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 2,
        label: constants.PARTNERPLAN.STEPS.SUBMIT,
        desc: `${constants.PARTNERPLAN.STATUS.SUBMITTED}: ${(partnerPlan.partnerPlan.planSubmittedDate ?
          format(new Date(partnerPlan.partnerPlan.planSubmittedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 3,
        label: constants.PARTNERPLAN.STEPS.AGREED,
        desc: `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_AGREED}: ${(partnerPlan.partnerPlan.planAgreedDate ?
          format(new Date(partnerPlan.partnerPlan.planAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,        
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 4,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
        desc: '',
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 5,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
        desc: `${partnerPlan.partnerPlan.interimCounsellee ? `"${partnerPlan.partnerPlan.interimCounsellee}" ${constants.PARTNERPLAN.PROGRESS_LABEL.PARTNER_RATING_SUBMITTED}:   
          ${(partnerPlan.partnerPlan.interimDate ? format(new Date(partnerPlan.partnerPlan.interimDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 6,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
        desc: `${(selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP && partnerPlan.partnerPlan.interimCounsellor) ? `"${partnerPlan.partnerPlan.interimCounsellor}"` : ''} ${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_RATING_AGREED}:         
        ${(partnerPlan.partnerPlan.interimAgreedDate ? format(new Date(partnerPlan.partnerPlan.interimAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        desc2: `${(partnerPlan.partnerPlan.interimRatingVisibility === true && partnerPlan.partnerPlan.finalAgreedInterimRating) ? `"${partnerPlan.partnerPlan.finalAgreedInterimRating}" ${constants.PARTNERPLAN.PROGRESS_LABEL.FINAL_AGREED_INTERIM_RATING}:
          ${(partnerPlan.partnerPlan.finalAgreedInterimRatingSaved ? format(new Date(partnerPlan.partnerPlan.finalAgreedInterimRatingSaved), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        highlight: true,
        actions: [
          {
            label: 'VIEW NOTES',
            onClick: handleInterimCounsellorAssessmentNotes,
            active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP),
          },
        ],
      },
      {
        key: 7,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
        desc: '',
        isDone: true,
        isCurrent: false,
        actions: [
          {
            label: 'SUPPORTING DOCUMENTS',
            onClick: handleFinalSelfAssessment,
            active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.MYPLANS),
          },
        ],
      },
      {
        key: 8,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
        desc: `${partnerPlan.partnerPlan.finalCounselleeAssessment ? `"${partnerPlan.partnerPlan.finalCounselleeAssessment}" ${constants.PARTNERPLAN.PROGRESS_LABEL.PARTNER_RATING_SUBMITTED}:   
          ${(partnerPlan.partnerPlan.finalDate ? format(new Date(partnerPlan.partnerPlan.finalDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: true,
        actions: [
          {
            label: 'ASSESS',
            onClick: handleFinalCounsellorAssessment,
            // active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP),
          },
        ],
      },
      {
        key: 9,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
        desc: '',
        isDone: false,
        isCurrent: false,
        actions: [],
      },
    ]

    return (
      <Progress steps={steps} />
    )
  }
}

export default FinalCounsellorAssessment



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/FinalCounsellorAssessment.js